import Ajax from '@/lib/ajax'
import Util from '@/lib/util'

export default {
  /**
   * 获取套装列表
   */
  getProductOutfitList(currentPage: number, pageSize: number, filter?: string, Published?: any, groupId?: string) {
    let params = {
      SkipCount: currentPage - 1 <= 0 ? 0 : (currentPage - 1) * pageSize,
      MaxResultCount: pageSize,
      Filter: filter,
    }
    if (Published != null) {
      params['Published'] = Published
    }
    if(groupId) {
      params['GroupId'] = groupId
    }
    return Ajax.get(`/api/MarketingManagement/ProductOutfit`, {
      params,
    })
  },
  /**
   * 新增套装
   */
  postProductOutfit(obj: any) {
    return Ajax.post(`/api/MarketingManagement/ProductOutfit`, obj)
  },
  /**
   * 更新套装
   */
  updateProductOutfit(id: string, obj: any) {
    return Ajax.put(`/api/MarketingManagement/ProductOutfit/${id}`, obj)
  },
  /**
   * 获取套装
   */
  getProductOutfitDetial(id: string) {
    return Ajax.get(`/api/MarketingManagement/ProductOutfit/${id}`)
  },
  /**
   * 删除套装
   */
  deleteProductOutfit(id: string | number) {
    return Ajax.delete(`/api/MarketingManagement/ProductOutfit/${id}`)
  },
  /**
   * 修改发布状态
   */
  updatePublished(id: string) {
    return Ajax.put(`/api/MarketingManagement/PromotionActivity/published/${id}`)
  },
  /**
   * 批量修改发布状态
   */
  updatedPublishedList(ids: any[]) {
    return Ajax.put(`/api/MarketingManagement/PromotionActivity/listPublished`, ids)
  },
  /**
   * 批量删除套装
   */
  deleteProductOutfitAll(ids: any[]) {
    return Ajax.delete(`/api/MarketingManagement/ProductOutfit/list` + Util.serialize({ ids }))
  },
  /**
   * 批量上下架
   */
  publishedProductOutfitAll(data: any) {
    return Ajax.put(`/api/MarketingManagement/ProductOutfit/published`, data)
  },
  /**
   * 批量导出
   */
  exportAllOutfit(keyWord: string) {
    return Ajax.get('/api/MarketingManagement/ProductOutfit/exportOutfitFile', {
      responseType: "blob",
      params:{
        keyWord
      }
    })
  }
}
